export default __webpack_public_path__ + "static/media/recommendation-card-blurred-background.a4dc9661.png";